import { hookstate } from "@hookstate/core";
import { LayoutScaleProps } from "../types";

export type CardLayoutState = {
  comics: {
    calendar_c_1: LayoutScaleProps;
    r_list: LayoutScaleProps;
  };
};

export const cardLayoutStore = hookstate<CardLayoutState>({
  comics: {
    calendar_c_1: { scaleY: 1, scaleX: 1 },
    r_list: { scaleY: 1, scaleX: 1 },
  },
});
